import React from 'react';
import * as LucideIcons from 'lucide-react';
import { IconProps } from '@/types';

const Icon: React.FC<IconProps> = ({ name, size = 20, className = '', strokeWidth = 2, ...props }) => {
  const IconComponent = LucideIcons[name as keyof typeof LucideIcons] as React.ComponentType<any>;

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react`);
    return null;
  }

  return <IconComponent size={size} className={className} strokeWidth={strokeWidth} {...props} />;
};

export default Icon;
